import { call, put, takeEvery } from '@redux-saga/core/effects';
import { createAction, handleActions } from 'redux-actions';
import { PATH_DELIMITER, SYSTEM_UNIVERSITY_MANAGER_PATH } from '../../../constant/Constant';
import { request } from '../../ApiModule';
import { defaultGridData } from '../../../module/component/TableBoxModule';
import NullCheckUtil from '../../../util/NullCheckUtil';
import { SET_GRID_DATA } from '../../component/TableBoxModule';

const ACTION_STAFF_BY_UNIVERSITY_SEARCH =
    SYSTEM_UNIVERSITY_MANAGER_PATH + PATH_DELIMITER + 'ACTION_STAFF_BY_UNIVERSITY_SEARCH';
const ACTION_STAFF_BY_UNIVERSITY_ADD =
    SYSTEM_UNIVERSITY_MANAGER_PATH + PATH_DELIMITER + 'ACTION_STAFF_BY_UNIVERSITY_ADD';
const ACTION_STAFF_BY_UNIVERSITY_EDIT =
    SYSTEM_UNIVERSITY_MANAGER_PATH + PATH_DELIMITER + 'ACTION_STAFF_BY_UNIVERSITY_EDIT';
const ACTION_STAFF_BY_UNIVERSITY_REMOVE =
    SYSTEM_UNIVERSITY_MANAGER_PATH + PATH_DELIMITER + 'ACTION_STAFF_BY_UNIVERSITY_REMOVE';
const ACTION_STAFF_BY_UNIVERSITY_PWRESET =
    SYSTEM_UNIVERSITY_MANAGER_PATH + PATH_DELIMITER + 'ACTION_STAFF_BY_UNIVERSITY_PWRESET';

export const actionStaffByUniversitySearch = createAction(ACTION_STAFF_BY_UNIVERSITY_SEARCH);
export const actionStaffByUniversityAdd = createAction(ACTION_STAFF_BY_UNIVERSITY_ADD);
export const actionStaffByUniversityEdit = createAction(ACTION_STAFF_BY_UNIVERSITY_EDIT);
export const actionStaffByUniversityRemove = createAction(ACTION_STAFF_BY_UNIVERSITY_REMOVE);
export const actionStaffByUniversityPwreset = createAction(ACTION_STAFF_BY_UNIVERSITY_PWRESET);

export function* systemUniversityManagerSagas() {
    yield takeEvery(ACTION_STAFF_BY_UNIVERSITY_SEARCH, actionStaffByUniversitySearchSaga);
    yield takeEvery(ACTION_STAFF_BY_UNIVERSITY_ADD, actionStaffByUniversityAddSaga);
    yield takeEvery(ACTION_STAFF_BY_UNIVERSITY_EDIT, actionStaffByUniversityEditSaga);
    yield takeEvery(ACTION_STAFF_BY_UNIVERSITY_REMOVE, actionStaffByUniversityRemoveSaga);
    yield takeEvery(ACTION_STAFF_BY_UNIVERSITY_PWRESET, actionStaffByUniversityPwresetSaga);
}

function* actionStaffByUniversitySearchSaga({ payload: { params, callback } }) {
    const result = yield call(request, {
        method: 'get',
        url: '/api/users',
        params,
        callback,
    });
    if (NullCheckUtil.isNotEmpty(result)) {
        yield put({
            type: SET_GRID_DATA,
            payload: result,
        });
    }
}

function* actionStaffByUniversityAddSaga({ payload: { data, callback } }) {
    const result = yield call(request, {
        method: 'post',
        url: '/api/users/staff',
        data,
    });

    if (NullCheckUtil.isNotEmpty(result) && result == 1) {
        yield call(request, {
            method: 'post',
            url: '/api/email/staff-sign-up',
            data,
        });
        callback && callback(data);
    }
}

function* actionStaffByUniversityEditSaga({ payload: { data, callback } }) {
    yield call(request, {
        method: 'put',
        url: `/api/users/${data.userId}/change-info`,
        data,
        callback,
    });
}

function* actionStaffByUniversityRemoveSaga({ payload: { params, callback } }) {
    yield call(request, {
        method: 'delete',
        url: `/api/users/${params.userId}`,
        params,
        callback,
    });
}

function* actionStaffByUniversityPwresetSaga({ payload: { data, callback } }) {
    yield call(request, {
        method: 'post',
        url: '/api/email/reset-password',
        data,
        callback,
    });
}
